"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgWifi(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm8.00879 12.00313a.99846.99846 0 1 1 -.99106 1.0058v-.00731a.99483.99483 0 0 1 .99106-.99849zm.0001-3.59a4.34922 4.34922 0 0 0 -3.42371 1.67064.36319.36319 0 0 0 .03566.485l.51718.521a.35055.35055 0 0 0 .24964.10781h.01778a.338.338 0 0 0 .26753-.14372 2.89408 2.89408 0 0 1 4.67194 0 .314.314 0 0 0 .26753.14372h.01778a.35057.35057 0 0 0 .24965-.10781l.51717-.521a.38278.38278 0 0 0 .03566-.485 4.37539 4.37539 0 0 0 -3.42381-1.67064zm0-3.08975a7.4074 7.4074 0 0 0 -5.58141 2.55081.3433.3433 0 0 0 .01788.485l.51707.52094a.35071.35071 0 0 0 .24965.10781h.01792a.31144.31144 0 0 0 .24965-.12571 5.96424 5.96424 0 0 1 9.05867 0 .37367.37367 0 0 0 .24964.12571h.01778a.35078.35078 0 0 0 .24975-.10781l.51707-.52094a.36077.36077 0 0 0 .01788-.485 7.46432 7.46432 0 0 0 -5.58155-2.55081zm7.89965.19751a10.73014 10.73014 0 0 0 -7.89965-3.52089 10.769 10.769 0 0 0 -7.91743 3.52089.36607.36607 0 0 0 .01788.50305l.51717.50294a.35057.35057 0 0 0 .24965.10781.28861.28861 0 0 0 .24964-.12569 9.31888 9.31888 0 0 1 6.86531-3.07188 9.30953 9.30953 0 0 1 6.88319 3.08976.474.474 0 0 0 .24964.12581.35071.35071 0 0 0 .24965-.10781l.51707-.52094a.36607.36607 0 0 0 .01788-.50305z' })));
}
exports.default = SvgWifi;
